export enum QuoteStatus {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    CANCELED = 'CANCELED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    EXPIRED = 'EXPIRED',
    DELETED = 'DELETED'
}

export enum Flag {
    All = 'ALL',
    SELF = 'SELF'
}
